<template>
  <a class="category-card" :href="langUrl">
    <slot />
  </a>
</template>

<script>
import {getDocumentLang} from '../../main/utils';

export default {
  props: {
    url: {type: String, required: true}
  },
  computed: {
    langUrl() {
      return `${getDocumentLang() === 'en' ? '' : `/${getDocumentLang()}`}${this.url}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.category-card {
  color: $color-gray-700;
  @include text('sm');
  margin-top: 8px;
  padding: 8px;

  text-align: center;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 1px solid $color-gray-400;
  border-radius: 8px;
  transition: all 250ms cubic-bezier(0.23, 1, 0.32, 1);
  transition-property: background-color, color, border-color;

  &:hover,
  &:focus,
  &:active {
    color: $color-blue-400;
    background: $color-blue-50;

    p {
      font-weight: $font-weight-medium;
    }
  }
}
</style>
